import { getAuthCode } from "./getAuthCode";
export const fetchPaymentDetails = async (id) => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL + "/fetchPaymentDetails";
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      return result
    } catch (error) {
      console.log(error);
    }
  };